import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/react';
import { CheckIcon, GlobeAltIcon } from '@heroicons/react/20/solid';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';

/** UI language picker: native names, no flags. Persists and updates <html lang> through i18n. */
export const LanguageSwitcher = () => {
    const { t } = useTranslation();
    const { code, current, languages, change } = useLanguage();
    return (
        <Menu>
            <MenuButton
                aria-label={t('ui.language.label', { code: code.toUpperCase(), name: current.label })}
                className="inline-flex h-control items-center gap-2 rounded-control px-3 text-caption font-semibold uppercase text-strong transition-colors duration-hover ease-snap hover:bg-hover"
            >
                <GlobeAltIcon className="size-5" aria-hidden="true" />
                {code}
            </MenuButton>
            <MenuItems
                anchor="bottom end"
                transition
                className="z-40 min-w-44 rounded-control bg-raised p-1 shadow-e2 outline-none transition duration-hover ease-snap [--anchor-gap:4px] data-[closed]:opacity-0"
            >
                {languages.map((l) => (
                    <MenuItem key={l.code}>
                        <button
                            type="button"
                            role="menuitemradio"
                            aria-checked={l.code === code}
                            lang={l.code}
                            onClick={() => change(l.code)}
                            className="flex min-h-11 w-full items-center justify-between gap-3 rounded-lg px-3 text-body text-strong data-[focus]:bg-hover"
                        >
                            {l.label}
                            {l.code === code && <CheckIcon className="size-5" aria-hidden="true" />}
                        </button>
                    </MenuItem>
                ))}
            </MenuItems>
        </Menu>
    );
};
